export default __webpack_public_path__ + "static/media/Speranza_084.52cd9a9b.jpg";